module.exports = __webpack_public_path__ + "img/kav_no.4534afa3.png";